
namespace TabAurous.Retail {

    import fld = POSSalesItemsRow.Fields; 
    @Serenity.Decorators.registerClass()
    export class FootfallAndSales extends Serenity.EntityGrid<POSSalesItemsRow, any> {
        protected getColumnsKey() { return 'Retail.FootfallAndSales'; }
        protected getDialogType() { return POSSalesItemsDialog; }
        protected getIdProperty() { return POSSalesItemsRow.idProperty; }
        protected getInsertPermission() { return POSSalesItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return POSSalesItemsRow.localTextPrefix; }
        protected getService() { return FootfallAndSalesService.baseUrl; }
        private chartContainer: JQuery;
        private chartPanel: Reports.LineChartPanel;
        constructor(container: JQuery) {
            super(container);
            this.setTitle("");
            //this.addDateRangeFilter("Date",);
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {
            let filters = super.getQuickFilters();
            var year = new Date().getFullYear();
            filters.unshift({
              //  field: fld.InsertDate,
                type: Serenity.DateEditor,
                title: 'Month',
                element: function (e1) {
                    e1.prop('readonly', true), // Para evitar problemas con el ingreso de datos manualmente

                        e1.datepicker({
                            yearRange: (year - 2).toString() + ":" + year.toString(),
                            dateFormat: 'mm/yy',
                            changeMonth: true,
                            changeYear: true,
                            showButtonPanel: true,
                            closeText: 'Apply',

                            onClose: function (dateText, inst) {
                                function isDonePressed() {
                                    return ($('#ui-datepicker-div').html().indexOf('ui-datepicker-close ui-state-default ui-priority-primary ui-corner-all ui-state-hover') > -1);
                                }

                                if (isDonePressed()) {
                                    e1.triggerHandler('change');
                                    var month = $("#ui-datepicker-div .ui-datepicker-month :selected").val();
                                    var year = $("#ui-datepicker-div .ui-datepicker-year :selected").val();
                                    $(this).datepicker('setDate', new Date(year, month, 1));
                                    $('.date-picker').focusout()
                                }
                            },
                        });
                    e1.focus(() => {
                        $('.ui-datepicker-calendar').css('display', 'none');
                    });
                },
                init: w => {
                    const date = new Date();
                    (w as Serenity.DateEditor).value = q.formatDate(date.toDateString(), 'MM/yyyy');
                },
                handler: args => {
                    if (args.active) {
                        var dateParts = args.value.split("/");
                        const startDate = new Date(+dateParts[1], dateParts[0] - 1, 1);
                        const endDate = q.addMonths(startDate, 1);

                        args.request.Criteria = Serenity.Criteria.and(args.request.Criteria, [[fld.TransDate], '>=', startDate.toDateString()]);
                        (this.view.params as ReportFiltersRequest).FromYear = startDate.toDateString();
                        //args.request.Criteria = Serenity.Criteria.and(args.request.Criteria, [[fld.InsertDate], '<', endDate.toDateString()]);
                    }
                }
            });

            return filters;
        } 
        protected getButtons(): Serenity.ToolButton[] {
            super.getButtons();
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            buttons.push({

                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: 'Reports.ApprovalRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            });
            return buttons;
        }

    }
}